/** Monta o link "acompanhar meus chamados" a partir do que o intake devolveu no 202.
    Puro de propósito: é a única parte com regra de verdade (validação do endereço +
    o `?email=` que pré-preenche o login por link), e assim fica coberta por teste.

    `portalUrl` vem da NOSSA API, mas ainda assim só aceita http/https: um valor de
    config errado não deve virar `javascript:` num href dentro da página anfitriã.
    Sem e-mail o link continua válido — a pessoa digita o dela na tela de login. */
export function linkDoPortal(portalUrl?: string, email?: string): string | null {
  if (!portalUrl) return null;
  let u: URL;
  try {
    u = new URL(portalUrl);
  } catch {
    return null;
  }
  if (u.protocol !== "http:" && u.protocol !== "https:") return null;
  const limpo = (email ?? "").trim();
  if (limpo !== "") u.searchParams.set("email", limpo);
  return u.toString();
}
